/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A_Fatura_IptalInputs */

const tr_faq_a_fatura_iptal = /** @type {(inputs: Faq_A_Fatura_IptalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sipariş iptal edildiğinde sistem QNB eSolutions üzerinden otomatik iptal faturası (iade faturası) düzenler. Yanlış kesilen faturalarda da aynı akış işler: önce iptal, ardından doğru bilgilerle yeni fatura. İptal işlemi sadece gün sonu kapanmadan önce yapılabilir; kapandıktan sonraki faturalar için iade faturası yolu izlenir.`)
};

const en_faq_a_fatura_iptal = /** @type {(inputs: Faq_A_Fatura_IptalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When an order is cancelled the system automatically issues a cancellation invoice via QNB eSolutions. For same-day cancellations the original invoice is voided; for later dates a credit note is issued instead.`)
};

const de_faq_a_fatura_iptal = /** @type {(inputs: Faq_A_Fatura_IptalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei einer Bestellstornierung erstellt das System automatisch eine Stornorechnung über QNB eSolutions. Taggleiche Stornierungen löschen die ursprüngliche Rechnung; spätere erhalten eine Gutschrift.`)
};

const ru_faq_a_fatura_iptal = /** @type {(inputs: Faq_A_Fatura_IptalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`При отмене заказа система автоматически создаёт аннуляцию через QNB eSolutions. Если отмена в тот же день, исходный счёт аннулируется; в остальных случаях создаётся кредит-нота.`)
};

/**
* | output |
* | --- |
* | "When an order is cancelled the system automatically issues a cancellation invoice via QNB eSolutions. For same-day cancellations the original invoice is void..." |
*
* @param {Faq_A_Fatura_IptalInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_a_fatura_iptal = /** @type {((inputs?: Faq_A_Fatura_IptalInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A_Fatura_IptalInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_a_fatura_iptal(inputs)
	if (locale === "de") return de_faq_a_fatura_iptal(inputs)
	if (locale === "ru") return ru_faq_a_fatura_iptal(inputs)
	return tr_faq_a_fatura_iptal(inputs)
});